module.exports = __webpack_public_path__ + "static/media/salaoDeBeleza.413d1d66.jpg";